let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bL008")).then(() => parcelRequire('l1U4U'));